export default class BlockRealization {
	constructor() {

		let blocks = document.querySelectorAll('.block-realization');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			const pagination = block.querySelector('.swiper-custom-pagination');
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			new Swiper(swiper, {
				slidesPerView: 1,
				grabCursor: true,
				spaceBetween: '20px',
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
